import React, { useEffect, useContext } from 'react';
import { Button, Headline2, Headline3 } from 'venn-ui-kit';
import type { FallbackComponent } from './CustomizableErrorBoundary';
import { ErrorWrapper } from './CustomizableErrorBoundary';
import { ThemeContext } from 'styled-components';

const DeveloperFallbackComponent: FallbackComponent = (props) => {
  const { Colors } = useContext(ThemeContext);

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const replaceNewlines = (s: string) => {
    return s.replaceAll(/(\\r)?\\n/g, '\n');
  };

  const getErrorString = (error: Error) => {
    try {
      return replaceNewlines(JSON.stringify(error, Object.getOwnPropertyNames(error), 2));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return 'Failed to convert error to string. See error in console.';
    }
  };

  return (
    <ErrorWrapper style={{ backgroundColor: Colors.White, padding: 16 }}>
      <Headline2>Developer Error Boundary</Headline2>
      <Button onClick={props.onRetry}>Retry</Button>

      {props.error && <ErrorDetailSection header="Error Object" body={getErrorString(props.error)} />}
      <ErrorDetailSection header="Info" body={replaceNewlines(props.info)} />
    </ErrorWrapper>
  );
};

const ErrorDetailSection = ({ header, body }: { header: string; body: string }) => {
  return (
    <>
      <Headline3>{header}</Headline3>
      <div
        style={{ maxWidth: '80vw', maxHeight: '25vh', overflow: 'scroll', whiteSpace: 'pre', border: '1px solid grey' }}
      >
        {body}
      </div>
    </>
  );
};

export default DeveloperFallbackComponent;
